import { render, staticRenderFns } from "./SubjectTeacherCreate.vue?vue&type=template&id=303a0102"
import script from "../../controllers/subject_teacher/subject_teacher-create.js?vue&type=script&lang=js&external"
export * from "../../controllers/subject_teacher/subject_teacher-create.js?vue&type=script&lang=js&external"
import style0 from "./SubjectTeacherCreate.vue?vue&type=style&index=0&id=303a0102&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports